<div style="display: flex; justify-content: space-between; align-items: center;">
    <h2 mat-dialog-title style="font-weight: bold; margin: 0;">Application Details</h2>
    <div style="display: flex;justify-content: center;gap: 18px;">
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search"
            style="font-size: 17px; border-radius: 5px;">
        <mat-icon (click)="onCancel()"
            style="font-weight: bold; color: rgb(85, 84, 84); cursor: pointer;">close</mat-icon>
    </div>
</div>
<div fxLayout="column" class="scroll-div">
    <mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="studentCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Student Code </mat-header-cell>
            <mat-cell *matCellDef="let element" style=" text-align: center; justify-content: right;">
                {{element.StudentCode}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="applicantCode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Application Code </mat-header-cell>
            <mat-cell *matCellDef="let element" style="text-align: center; justify-content: center;">
                {{element.ApplicationCode}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; justify-content: center;">
                Name </mat-header-cell>
            <mat-cell *matCellDef="let element" style="text-align: center; justify-content: center;">
                {{element.FullName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center; justify-content: center;">
                Category </mat-header-cell>
            <mat-cell *matCellDef="let element" style="text-align: center; justify-content: center;">
                {{element.CategoryName}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="pwd">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                style="width: 40px; text-align: center; justify-content: center;"> Pwd </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 40px; text-align: center; justify-content: center;">
                {{element.PWDFlag==1?'Yes':'No'}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="meritindOne">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                style="width: 80px; text-align: center; justify-content: center;"> Merit Index </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 80px; text-align: center; justify-content: center;">
                {{element.MeritIndexOne}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="gmr">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                style="width: 40px; text-align: center; justify-content: center;"> GMR </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 40px; text-align: center; justify-content: center;">
                {{element.GeneralMeritRank}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="cmr">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                style="width: 40px; text-align: center; justify-content: center;"> CMR </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 40px; text-align: center; justify-content: center;">
                {{element?.CategoryMeritRank}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="prefNo">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                style="width: 80px; text-align: center; justify-content: center;"> Preference No </mat-header-cell>
            <mat-cell *matCellDef="let element" style="width: 80px; text-align: center; justify-content: center;">
                {{element.PreferenceSeq}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="subjectCombination">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Subject Combination </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.SubjectComboNarration}} </mat-cell>
        </ng-container>
        <ng-container matColumnDef="applicationDetails" stickyEnd>
            <mat-header-cell class="justify-content-center" *matHeaderCellDef> Application Details </mat-header-cell>
            <mat-cell class="justify-content-center" *matCellDef="let element">
                <a mat-icon-button style="cursor:pointer;" color="primary"
                    (click)="downloadApplicationPDF('68bca00b-ad12-4106-a22f-381d764d0092', 'Application.pdf', element.StudentId)">
                    <mat-icon>print</mat-icon>
                </a>
            </mat-cell>
        </ng-container>
        <mat-header-row class="custom-header-row" *matHeaderRowDef="displayedColumns; sticky: true;"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div>